import type { CreateAgencyInput } from '@idc-forms/schemas'
import { useSidePanelStore } from '@/shared/store/side-panel.store'
import { useCreateAgencyMutation } from '../hooks/use-agency-mutations'
import { AgencyForm } from './agency-form'

type AgencyCreatePanelProps = {
  onDone?: () => void
}

/** "Nueva agencia" dentro del side panel: el mismo AgencyForm que la edición. */
export function AgencyCreatePanel({ onDone }: AgencyCreatePanelProps) {
  const closePanel = useSidePanelStore((s) => s.closePanel)
  const createMutation = useCreateAgencyMutation()
  const done = onDone ?? closePanel

  const handleSubmit = (values: CreateAgencyInput) => {
    createMutation.mutate(values, {
      onSuccess: () => {
        done()
      }
    })
  }

  return (
    <AgencyForm
      submitLabel="Crear agencia"
      pending={createMutation.isPending}
      onSubmit={handleSubmit}
      onCancel={done}
    />
  )
}
